import axios from "axios";

/** localStorage key of the signed-in admin session. */
export const AUTH_STORAGE_KEY = "hoopslam_admin";

/** Axios client for hoopslam-backend. */
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "",
});

api.interceptors.request.use((config) => {
  try {
    const user = JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY));
    if (user?.token) config.headers.Authorization = `Bearer ${user.token}`;
  } catch {
    // No stored session: send the request without a token.
  }
  return config;
});

/**
 * Best user-facing message for a failed request.
 * @param error - The axios error.
 * @param fallback - Message when the backend sent none.
 */
export function apiError(error, fallback = "Something went wrong. Please try again.") {
  const data = error?.response?.data;
  return data?.error || data?.message || fallback;
}
